module.exports = __webpack_public_path__ + "static/media/lightndark.fedf752b.woff";